/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationsacuityAcuityIntegration1 from './IntegrationsacuityAcuityIntegration1';

/**
 * The IntegrationsMdiBody1 model module.
 * @module model/IntegrationsMdiBody1
 * @version v0.3
 */
export default class IntegrationsMdiBody1 {
  /**
   * Constructs a new <code>IntegrationsMdiBody1</code>.
   * @alias module:model/IntegrationsMdiBody1
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsMdiBody1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsMdiBody1} obj Optional instance to populate.
   * @return {module:model/IntegrationsMdiBody1} The populated <code>IntegrationsMdiBody1</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsMdiBody1();
      if (data.hasOwnProperty('mdi_integration'))
        obj.mdiIntegration = IntegrationsacuityAcuityIntegration1.constructFromObject(data['mdi_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationsacuityAcuityIntegration1} mdiIntegration
 */
IntegrationsMdiBody1.prototype.mdiIntegration = undefined;

